import { ReactNode, ReactElement } from "react";
import classnames from "classnames";

export function LabelledField({
  id,
  children,
  className,
}: {
  id: string;
  children: ReactNode;
  className?: string;
}): ReactElement {
  return (
    <label className={classnames(["formFieldLabel", className])} id={id}>
      {children}
    </label>
  );
}
